import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DAB_FEATURE_NAME } from './configurations';
import { DabService } from './services/dab.service';
import { DabEffects } from './state/dab.effects';
import { DAB_FEATURE_KEY, initialState, reducers } from './state/reducer';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(DAB_FEATURE_KEY, reducers, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([DabEffects]),
    ConfigurationModule.forFeature(DAB_FEATURE_NAME),
  ],
  providers: [DabService],
})
export class DabStateModule {}
